import { Check } from "lucide-react";
import { Reveal } from "./Reveal";

const reasons = [
  "A variety of breakfast options, served all day",
  "South Indian and North Indian food under one roof",
  "Multi-cuisine dining — Indian and international dishes",
  "A welcoming, relaxed cafe atmosphere",
  "Convenient location on Anjuna Beach Road, North Goa",
];

export const Story = () => (
  <section id="story" className="relative px-5 py-24 sm:px-8 sm:py-32" data-testid="story-section">
    <div className="mx-auto grid max-w-7xl gap-14 lg:grid-cols-[1.05fr_1fr] lg:gap-20">
      <Reveal>
        <p className="eyebrow mb-5">01 · Welcome</p>
        <h2 className="font-display text-3xl leading-[1.2] tracking-tight text-cream sm:text-4xl">
          A royal table,
          <br />
          <span className="gold-text italic">in the heart of Anjuna.</span>
        </h2>
        <div className="mt-10 flex gap-10 border-t border-gold/15 pt-8">
          <div>
            <p className="font-display text-3xl text-gold-light">15h</p>
            <p className="mt-1 font-mono text-[0.62rem] uppercase tracking-[0.22em] text-ash">Open daily</p>
          </div>
          <div>
            <p className="font-display text-3xl text-gold-light">9+</p>
            <p className="mt-1 font-mono text-[0.62rem] uppercase tracking-[0.22em] text-ash">Specialities</p>
          </div>
          <div>
            <p className="font-display text-3xl text-gold-light">3</p>
            <p className="mt-1 font-mono text-[0.62rem] uppercase tracking-[0.22em] text-ash">Meals a day</p>
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="text-base leading-relaxed text-ash sm:text-lg">
          Welcome to The Royal Cafe, Anjuna — your destination for delicious breakfast, lunch and dinner in North Goa.
          We serve a variety of Indian and international dishes in a welcoming cafe atmosphere, from South Indian
          breakfast and North Indian cuisine to continental plates and multi-cuisine favourites.
        </p>
        <p className="mt-5 text-base leading-relaxed text-ash">
          Whether you're looking for an early-morning breakfast, a relaxed lunch or a satisfying dinner, The Royal
          Cafe welcomes you.
        </p>
        <ul className="mt-8 space-y-3.5">
          {reasons.map((reason) => (
            <li key={reason} className="flex items-start gap-3 text-sm text-cream/85">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-gold/40 bg-gold/10">
                <Check size={11} className="text-gold-light" />
              </span>
              {reason}
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
